import React, { useState, useEffect, useContext } from "react";
import ReusableModal from "../ManageSettings/ReusableModal";
import { toast, ToastContainer } from "react-toastify";
import "./Gas.css";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import Swal from "sweetalert2";
import taxIcon from "../../../../assets/Image/Tax PV (Black).png";
import { capitalizeFirstLetter } from "../../../../utils/helper/common";
import { CustomButton, RegularButton } from "../../../common/ReusableComponent/CustomButton";
import { ReusableInput, SelectInput } from "../../../common/ReusableComponent/ReusableInput";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";

function GasTaxSettings() {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { Get, Put, Post, Delete, getAPI , GetPaginatedData} = useApi();

  const [gasTypeData, setGasTypeData] = useState([]);
  const [gasType, setGasType] = useState("");
  const [taxName, setTaxName] = useState("");
  const [taxValue, setTaxValue] = useState("");
  const [gas, setGas] = useState([]);
  const [freightData, setFreightData] = useState([]);

  const [selectedGasTax, setSelectedGasTax] = useState(null);
  const [prevGasTaxValues, setPrevGasTaxValues] = useState(null);
  const [showTaxModal, setShowTaxModal] = useState(false);
  const [selectedFreight, setSelectedFreight] = useState(null);
  const [prevFreightValues, setPrevFreightValues] = useState(null);
  const [freightName, setFreightName] = useState("");
  const [freightValue, setFreightValue] = useState(""); 
  const [showFreightModal, setShowFreightModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [gasTaxRefreshTrigger, setGasTaxRefreshTrigger] = useState(0);
  const [freightRefreshTrigger, setFreightRefreshTrigger] = useState(0);

const fetchDatas = async ({
  apiKey,setStateCallback,page="1",searchTerm = "",sort = "",order = ""
} = {}) => {
  try {
    setLoading(true);

    const response = await GetPaginatedData(apiKey, {
      page,
      search: searchTerm,
      queryParams: {
        ...(sort && { sort }),
    
      },
    });

    const results = response?.data || [];
    const count = response?.totalCount || 0;
    const totalPages = Math.ceil(count / 10); 
    if (setStateCallback) {
      setStateCallback(results);
    }

    return { data: results, totalPages };
  } catch (error) {
    console.error(`Error fetching '${apiKey}' data:`, error);
    toast.error(`Failed to fetch ${apiKey} data.`);
    return { data: [], totalPages: 1 };
  } finally {
    setLoading(false);
  }
};


  const fetchGasTaxData = async ({ page = 1, searchTerm = "" }) => {
  return await fetchDatas({
    apiKey: "gasTaxData",
    page,
    searchTerm,
  });
};

const fetchFreightData = async ({ page = 1, searchTerm = "" }) => {
  return await fetchDatas({
    apiKey: "gasFreightData",
    page,
    searchTerm,
  });
};

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([
        fetchDatas({ apiKey: "gasTypeData", setStateCallback: setGasTypeData }),
        fetchDatas({ apiKey: "gasTaxData", setStateCallback: setGas }),
        fetchDatas({ apiKey: "gasFreightData", setStateCallback: setFreightData }),
      ]);
    };
    fetchAll();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "gas_type":
        setGasType(value);
        if (value) setErrors((prev) => ({ ...prev, gasType: "" }));
        break;
      case "tax_name":
        setTaxName(capitalizeFirstLetter(value));
        if (value.trim()) setErrors((prev) => ({ ...prev, taxName: "" }));
        break;
      case "tax_value":
        let val = parseFloat(value);
        if (val > 100) {
          val = 100;
          toast.info("Tax value cannot exceed 100%");
        } else if (val < 0) {
          val = 0;
          toast.error("Tax value cannot be negative");
        }
        setTaxValue(val);
        if (!isNaN(val)) setErrors((prev) => ({ ...prev, taxValue: "" }));
        break;
      case "freight_name":
        setFreightName(value);
        break;
      case "freight_value":
        setFreightValue(value); 
        break;
      default:
        break;
    }
  };

  const handleShowTax = () => setShowTaxModal(true);

  const handleCloseTax = () => {
    setTaxName("");
    setTaxValue("");
    setGasType("");
    setSelectedGasTax(null);
    setPrevGasTaxValues(null);
    setShowTaxModal(false);
    setErrors({});
  };

  const handleShowFreight = () => setShowFreightModal(true);

  const handleCloseFreight = () => {
    setSelectedFreight(null);
    setPrevFreightValues(null);
    setFreightName("");
    setFreightValue(""); 
    setShowFreightModal(false);
  };

  const handleEditGasTax = (gasTaxIdOrObject) => {
    console.log("Editing gas tax received:", gasTaxIdOrObject);
    console.log("Type:", typeof gasTaxIdOrObject);

    let gasTaxObject;

    if (typeof gasTaxIdOrObject === 'string') {

      gasTaxObject = gas.find(item => item.id === gasTaxIdOrObject);
      console.log("Found gas tax object by ID:", gasTaxObject);
    } else if (gasTaxIdOrObject && typeof gasTaxIdOrObject === 'object') {

      gasTaxObject = gasTaxIdOrObject;
    }

    if (!gasTaxObject || !gasTaxObject.id) {
      console.error("Invalid gas tax object or missing ID:", gasTaxObject);
      toast.error("Cannot edit: Invalid item selected");
      return;
    }

    console.log("Final gas tax object to edit:", gasTaxObject);

    setSelectedGasTax({ ...gasTaxObject }); 
    setPrevGasTaxValues({ ...gasTaxObject });

    setGasType(gasTaxObject.gas_type || "");
    setTaxName(gasTaxObject.tax_name || "");
    setTaxValue(gasTaxObject.tax_value || "");

    setErrors({});

    handleShowTax();
  };

  const handleSubmitTaxData = async (e) => {
    e.preventDefault();

    console.log("selectedGasTax:", selectedGasTax);
    console.log("selectedGasTax ID:", selectedGasTax?.id);
    console.log("Is editing:", !!(selectedGasTax && selectedGasTax.id));

    const newErrors = {};
    if (!taxName.trim()) newErrors.taxName = "Tax name is required";
    if (taxValue === "" || isNaN(taxValue)) newErrors.taxValue = "Valid tax value is required";
    if (!gasType) newErrors.gasType = "Gas type is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const gasTax = {
      gas_type: gasType,
      tax_name: taxName,
      tax_value: taxValue,
      store: storeId,
    };

    try {

      const isEditing = selectedGasTax && selectedGasTax.id;

      if (isEditing) {

        console.log("Updating gas tax with ID:", selectedGasTax.id);
        const response = await Put("gasTaxData", selectedGasTax.id, gasTax);

        setGas((prev) => 
          prev.map((item) => 
            item.id === selectedGasTax.id ? { ...item, ...gasTax, id: selectedGasTax.id } : item
          )
        );

        setGasTaxRefreshTrigger(prev => prev + 1);

        toast.success("Tax updated successfully!");
      } else {

        console.log("Creating new gas tax");
        const response = await Post("gasTaxData", gasTax);

        setGas((prev) => [...prev, response.data || { ...gasTax, id: Date.now() }]);

        setGasTaxRefreshTrigger(prev => prev + 1);

        toast.success("Tax added successfully!");
      }
    } catch (err) {
      console.error("Error saving tax data:", err);
      toast.error("Error saving tax data.");
    } finally {
      handleCloseTax();
    }
  };

  const handleDeleteGasTax = (idOrObject) => {

    const id = typeof idOrObject === 'string' ? idOrObject : idOrObject?.id;

    if (!id) {
      toast.error("Cannot delete: Invalid item selected");
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        await Delete("gasTaxData", id);

        setGas((prev) => prev.filter((item) => item.id !== id));

        setGasTaxRefreshTrigger(prev => prev + 1);

        toast.success("Tax deleted successfully!");
      } catch (err) {
        console.error("Error deleting tax:", err);
        toast.error("Failed to delete tax.");
      }
    });
  };

  const handleEditFreight = (freightIdOrObject) => {
    console.log("Editing freight received:", freightIdOrObject);
    console.log("Type:", typeof freightIdOrObject);

    let freightObject;

    if (typeof freightIdOrObject === 'string') {

      freightObject = freightData.find(item => item.id === freightIdOrObject);
      console.log("Found freight object by ID:", freightObject);
    } else if (freightIdOrObject && typeof freightIdOrObject === 'object') {

      freightObject = freightIdOrObject;
    }

    if (!freightObject || !freightObject.id) {
      console.error("Invalid freight object or missing ID:", freightObject);
      toast.error("Cannot edit: Invalid item selected");
      return;
    }

    console.log("Final freight object to edit:", freightObject);

    setSelectedFreight({ ...freightObject }); 
    setPrevFreightValues({ ...freightObject });

    setFreightName(freightObject.freight_name || "");
    setFreightValue(freightObject.freight_value || "");

    handleShowFreight();
  };

  const handleSubmitFreight = async (e) => {
    e.preventDefault();

    console.log("selectedFreight:", selectedFreight);
    console.log("selectedFreight ID:", selectedFreight?.id);

    if (!selectedFreight || !selectedFreight.id) {
      console.error("No freight item selected for update or missing ID");
      toast.error("No freight item selected for update.");
      return;
    }

    const updated = {
      freight_name: freightName,
      freight_value: freightValue, 
      store: storeId,
    };

    try {
      console.log("Updating freight with ID:", selectedFreight.id);
      const response = await Put("gasFreightData", selectedFreight.id, updated);

      setFreightData((prev) =>
        prev.map((item) => 
          item.id === selectedFreight.id ? { ...item, ...updated, id: selectedFreight.id } : item
        )
      );

      setFreightRefreshTrigger(prev => prev + 1);

      toast.success("Freight updated successfully!");
      handleCloseFreight();
    } catch (err) {
      console.error("Error updating freight:", err);
      toast.error("Failed to update freight.");
    }
  };

  const gasTypeOptions = [
    { id: "diesel", name: "Diesel" },
    { id: "gas", name: "Gas" },
    { id: "both", name: "Both" },
  ];

  const columns = [
    { header: "Tax Name", field: "tax_name" },
    { header: "Tax Value", field: "tax_value" },
    { header: "Gas Type", field: "gas_type" },
  ];

  const freightColumns = [
    { header: "Freight Name", field: "freight_name" },
    { header: "Freight Value", field: "freight_value" },
  ];

  return (
    <div>
      <ToastContainer />
      <div className="responsive-box">
        <div className="header-row">
          <div className="setting-title">Gas Tax Settings</div>
          <div className="btn-position" style={{ display: "flex", gap: "10px" }}>
            <CustomButton
              text="Add Tax"
              icon={taxIcon}
              onClick={handleShowTax}
              color="#000000"
              backgroundColor="#FFAF32"
              iconPosition="right"
            />
          </div>
        </div>

        <ReusableModal
          show={showTaxModal}
          handleClose={handleCloseTax}
          title={selectedGasTax ? "Edit Gas Tax" : "Add Gas Tax"}
          width="900px"
          height="auto"
        >
          <form onSubmit={handleSubmitTaxData}>
            <div className="d-flex align-items-center mt-3 mx-3" style={{ gap: "40px" }}>
              <ReusableInput
                type="text"
                name="tax_name"
                label="Tax Name"
                value={taxName}
                onChange={handleChange}
                error={errors.taxName}
                helperText={prevGasTaxValues ? `Previous: ${prevGasTaxValues.tax_name}` : ""}
              />
              <ReusableInput
                type="number"
                name="tax_value"
                label="Tax Value"
                value={taxValue}
                onChange={handleChange}
                error={errors.taxValue}
                helperText={prevGasTaxValues ? `Previous: ${prevGasTaxValues.tax_value}%` : ""}
              />
              <SelectInput
                name="gas_type"
                label="Gas Type"
                value={gasType}
                onChange={handleChange}
                options={gasTypeOptions}
                placeholder="Select Gas Type"
                error={errors.gasType}
                helperText={prevGasTaxValues ? `Previous: ${capitalizeFirstLetter(prevGasTaxValues.gas_type)}` : ""}
              />
            </div>
            <div className="d-flex justify-content-end mt-3 mx-3">
              <RegularButton text={selectedGasTax ? "Update" : "Submit"} type="submit" />
            </div>
          </form>
        </ReusableModal>

        <ReusableTable
          fetchData={fetchGasTaxData}
          columns={columns}
          showFooter={true}
          showAction={true}
          onEdit={handleEditGasTax}
          onDelete={handleDeleteGasTax}
          loading={loading}
          enablePagination={true}
          rowsPerPage={10}
          key={gasTaxRefreshTrigger} 
        />
      </div>

      <div className="responsive-box">
        <div className="header-row">
          <div className="setting-title">Gas Freight Settings</div>
        </div>

        <ReusableTable
          fetchData={fetchFreightData}
          columns={freightColumns}
          showFooter={true}
          showAction={true}
          onEdit={handleEditFreight}
          showDelete={false}
          loading={loading}
          enablePagination={true}
          rowsPerPage={10}
          key={freightRefreshTrigger} 
        />

        <ReusableModal
          show={showFreightModal}
          handleClose={handleCloseFreight}
          title="Edit Freight Data"
          width="600px"
          height="auto"
        >
          <form onSubmit={handleSubmitFreight}>
            <div className="form-group d-flex align-items-center mt-2">
              <ReusableInput
                type="text"
                name="freight_name"
                label="Freight Name"
                value={freightName}
                onChange={handleChange}
                readOnly
                helperText={prevFreightValues ? `Previous: ${prevFreightValues.freight_name}` : ""}
              />
              <ReusableInput
                type="number"
                name="freight_value"
                label="Freight Value"
                value={freightValue} 
                onChange={handleChange}
                required
                helperText={prevFreightValues ? `Previous: ${prevFreightValues.freight_value}` : ""}
              />
            </div>
            <div className="d-flex justify-content-end">
              <RegularButton text="Update" type="submit" />
            </div>
          </form>
        </ReusableModal>
      </div>
    </div>
  );
}

export default GasTaxSettings;